"use client";

import { useState, useEffect, useRef } from "react";

export function useAnimatedTab(activeTabId: string): {
  current: HTMLButtonElement | undefined;
  addRefs: (refLink: HTMLButtonElement | null, tabId: string) => void;
} {
  const refLinksRef = useRef<Record<string, HTMLButtonElement>>({});
  const [current, setCurrent] = useState<HTMLButtonElement | undefined>(
    undefined
  );

  const addRefs = (refLink: HTMLButtonElement | null, tabId: string) => {
    if (!refLink) {
      return;
    }

    refLinksRef.current[tabId] = refLink;
  };

  useEffect(() => {
    setCurrent(refLinksRef.current[activeTabId]);
  }, [activeTabId]);

  return {
    current,
    addRefs,
  };
}
